const NZ_DIAL_CODE = '64';

/**
 * Per acceptance criteria: an NZ number displays as "02X XXXXXXX" (leading 0, space after the
 * 3-digit prefix); any other country displays as "+<dial code> XXXXXXXXX". `phoneNumber` is
 * expected to be the national number as stored by the backend (no leading 0, no dial code) -
 * that's stripped defensively in case it's ever supplied with one. `countryCode` comes through
 * already carrying its own leading "+" (e.g. "+64") - normalised here rather than assumed, so a
 * bare dial code still works too - either way there's exactly one "+" in the output, never two.
 */
export const formatMemberPhoneNumber = (countryCode: string, phoneNumber: string): string => {
  const dialCode = countryCode.replace(/^\+/, '');
  const digits = phoneNumber.replace(/\D/g, '');

  if (dialCode === NZ_DIAL_CODE) {
    const national = digits.startsWith('0') ? digits : `0${digits}`;
    return national.length > 3 ? `${national.slice(0, 3)} ${national.slice(3)}` : national;
  }

  return `+${dialCode} ${digits}`;
};
